import React from 'react';
import styled from 'styled-components';
import { CcIcon } from '@utp/components-react';
import Icon from '@/presentation/reusables/Icon';
import { CardDetailWrapper, CardDetailGet } from './styled';

import SectionAddress from './components/SectionAddress';
import SectionConnection from './components/SectionConnection';
import SectionEnvironment from './components/SectionEnvironment';
import { formatDate, getHourAndMins } from './components/helpers/date';

interface IProps {
  contentData: any;
}

const CardDetailHeader = styled.div`
  padding: 0 16px;

  > h4 {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 900;
    line-height: 24px;
    text-transform: capitalize;

    > span {
      font-weight: 400;
    }
  }

  > ul {
    > li {
      display: flex;
      gap: 8px;
      align-items: center;
      margin-bottom: 6px;

      > svg {
        height: 16px;
        width: 16px;
        color: #283044;
      }

      > p {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }

      &:nth-of-type(1) {
        > p {
          font-weight: 700;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

const CardDetailBody = styled.div`
  padding: 0 16px;
  display: grid;
  grid-template-columns: 100%;
  gap: 12px;
`;

const CardDetail = ({ contentData }: IProps) => (
  <CardDetailWrapper>
    <CardDetailHeader>
      {/* <TagWrapper>Evaluación</TagWrapper> */}
      <h4>Evaluación: {contentData.name}</h4>
      <ul>
        <li>
          <Icon name="classroomFile" />
          <p>{contentData.description}</p>
        </li>
        <li>
          <Icon name="classroomCalendar" />
          <p>{formatDate(contentData.date)}</p>
        </li>
        <li>
          <Icon name="classroomClock" />
          <p>
            {getHourAndMins(contentData.start)} -{' '}
            {getHourAndMins(contentData.end)}
          </p>
        </li>
      </ul>
    </CardDetailHeader>
    <CardDetailGet>
      <div>
        {contentData.typeMod === 'P' ? (
          <>
            <CcIcon size={16} name="map-pin" />
            <span>¿Cómo llegar?</span>
          </>
        ) : (
          <>
            {contentData.idZoom ? (
              <>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <g>
                      <path
                        d="M7.33333 2.66671C5.49238 2.66671 4 4.15909 4 6.00004V8.66671C4 9.0349 3.70152 9.33337 3.33333 9.33337C2.22876 9.33337 1.33333 8.43794 1.33333 7.33337V6.40004C1.33333 5.514 1.99815 4.78323 2.85617 4.67936C3.42581 2.7452 5.2147 1.33337 7.33333 1.33337H8.66667C10.7807 1.33337 12.5664 2.73907 13.1401 4.66675C13.9843 4.67314 14.6667 5.35947 14.6667 6.20517V7.33337C14.6667 8.43794 13.7712 9.33337 12.6667 9.33337C12.2985 9.33337 12 9.0349 12 8.66671V6.00004C12 4.15909 10.5076 2.66671 8.66667 2.66671H7.33333Z"
                        fill="#283044"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 3.33337C6.15905 3.33337 4.66667 4.82576 4.66667 6.66671V7.33337C4.66667 9.17432 6.15905 10.6667 8 10.6667C9.84095 10.6667 11.3333 9.17432 11.3333 7.33337V6.66671C11.3333 4.82576 9.84095 3.33337 8 3.33337ZM10 7.33337V6.66671C10 5.56214 9.10457 4.66671 8 4.66671C6.89543 4.66671 6 5.56214 6 6.66671V7.33337C6 8.43794 6.89543 9.33337 8 9.33337C9.10457 9.33337 10 8.43794 10 7.33337Z"
                        fill="#283044"
                      />
                      <path
                        d="M5 11.3334C3.71133 11.3334 2.66667 12.378 2.66667 13.6667V14C2.66667 14.3682 2.96514 14.6667 3.33333 14.6667C3.70152 14.6667 4 14.3682 4 14V13.6667C4 13.1144 4.44771 12.6667 5 12.6667H11C11.5523 12.6667 12 13.1144 12 13.6667V14C12 14.3682 12.2985 14.6667 12.6667 14.6667C13.0349 14.6667 13.3333 14.3682 13.3333 14V13.6667C13.3333 12.378 12.2887 11.3334 11 11.3334H5Z"
                        fill="#283044"
                      />
                    </g>
                  </g>
                </svg>
                <span>Zoom</span>
              </>
            ) : (
              <></>
            )}
          </>
        )}
      </div>
    </CardDetailGet>
    <CardDetailBody>
      {contentData.typeMod === 'P' ? (
        <>
          <SectionEnvironment contentData={contentData} />
          <SectionAddress contentData={contentData} />
        </>
      ) : (
        <>
          {contentData.idZoom ? (
            <SectionConnection contentData={contentData} />
          ) : (
            <></>
          )}
        </>
      )}
    </CardDetailBody>
  </CardDetailWrapper>
);

export default CardDetail;
